import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { UPDATE_NAV_ITEM } from 'store/modules/statspro/stats-leaders/actions';
import { statsLeadersNavSelector } from 'store/modules/statspro/stats-leaders/selectors/nav-selector';
import { SvgIcon } from 'common/react/components/SvgIcon';

const entireSeasonTranslation = getTranslation(
    'label.statsLeaders.nav.round.entireSeason'
);

export const ResponsiveRoundNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(statsLeadersNavSelector);

    const roundsLoadError = useSelector(
        (state) => state.rounds[`season_${nav.season.id}`]?.error
    );

    const roundsList = useSelector(
        (state) => state.rounds[`season_${nav.season.id}`]?.list
    );

    const rounds = roundsList
        ? [
              { id: -1, name: entireSeasonTranslation, roundNumber: 0 },
              ...roundsList
          ]
        : [];

    return !roundsLoadError &&
        !(Array.isArray(rounds) && rounds.length === 0) ? (
        <div className="competition-nav__season-select">
            <SvgIcon
                icon="calendar"
                className="competition-nav__season-select-icon"
            />

            <SvgIcon
                className="competition-nav__season-select-chevron"
                icon="chevron-down"
            />

            <Select
                items={rounds}
                itemToString={(round) => round?.name}
                initialSelectedItem={
                    rounds && nav.round.id
                        ? rounds.find((s) => s.id === Number(nav.round.id))
                        : ''
                }
                activeItem={
                    rounds && nav.round.id
                        ? rounds.find((s) => s.id === Number(nav.round.id))
                        : ''
                }
                isReadyToRender={() => rounds?.length && Number(nav.round.id)}
                label={getTranslation('label.stats.round')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        UPDATE_NAV_ITEM.request({
                            navItem: 'round',
                            value: {
                                id: selectedItem.id,
                                number: selectedItem.roundNumber
                            }
                        })
                    );
                }}
                hideLabel
            />
        </div>
    ) : null;
};
